// @flow
import {put, call} from 'redux-saga/effects';
import {stopSubmit} from 'redux-form';
import {CommonActions} from '@react-navigation/native';

import type {SignUpActionType} from '../actions';

import HandleErrorService from '../../../lib/handleError';
import I18n from '../../../lib/i18n';

import {setLoading} from '../../LoadingStatus/actions';
import {setLogin} from '../Login';

import {goToNextActivationPage} from './goToNextActivationPage';

import config from '../../../config';
import Navigation from '../../../lib/navigation';
import {register} from './register';
import {fetchCustomerSaga} from '../../Customer/sagas';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* triggerEmailValidation(
  action: SignUpActionType,
): Generator<*, *, *> {
  if (
    action.type !== 'SIGNUP_TRIGGER_EMAIL_VALIDATION' &&
    action.type !== 'SIGNUP_TRIGGER_EMAIL_VALIDATION_DURING_ACTIVATE'
  )
    return; // for flow
  const page = action.type.includes('DURING_ACTIVATE')
    ? 'createAccountDuringActivate'
    : 'createAccount';
  const nextPage = action.type.includes('DURING_ACTIVATE')
    ? 'validateEmailDuringActivate'
    : 'validateEmail';
  yield put(setLoading(page, true));

  try {
    yield put(setLogin(action.payload));
    const response = yield call(register);
    if (!response || !response.errorCodeList) {
      throw new Error('no response or error code list');
    }
    if (response.errorCodeList.includes('LOGIN_ALREADY_EXISTS')) {
      yield put(
        stopSubmit(page, {
          _error: I18n.t('SignUp.CreateAccount.emailAlreadyUsed'),
        }),
      );
    } else if (response.errorCodeList.includes('PASSWORD_STRENGTH_TOO_LOW')) {
      yield put(stopSubmit(page, {password: I18n.t('invalidPassword')}));
    } else if (!response.errorCodeList.includes('BAD_ORDER_VALIDATION_CODE')) {
      yield call(fetchCustomerSaga);
      if (action.type.includes('DURING_ACTIVATE')) {
        yield call(goToNextActivationPage);
      } else {
        if (config.askPersonalInformationDuringOrderSim) {
          yield call(
            Navigation.dispatch,
            CommonActions.navigate({name: 'identityRequirements'}),
          );
        }
      }
    } else {
      yield call(Navigation.dispatch, CommonActions.navigate({name: nextPage}));
    }
  } catch (e) {
    WizzeeLog.warn('[saga] triggerEmailValidation', e);
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading(page, false));
  }
}
